module.exports = __webpack_public_path__ + "images/emoji/fireworks.a7eeab6a79c5d7d28f2e.png";